export const ON_BEHALF_OF_TOKEN = "onBehalfOfToken";
export const FEEDBACK_GIVEN = "feedbackGiven";
export const SCHEDULED_DATE_EMAIL = "scheduledDateEmail";
export const DISCOVER_SEARCH_PARAMS = "discoverSearchParams";
export const DISCOVER_METADATA_TAGS = "discoverMetadataTags";
export const HIDE_ONBOARDING_VIDEOS = "hideOnboardingVideos";

// DIALOGS
export const DISPLAY_SYNC_FOR_EMAIL_DIALOG = "displaySyncYourEmailDialog";
export const DISPLAY_SCHEDULED_DIALOG = "displayScheduleDialog";
export const DISPLAYED_CITY_DIALOG = "displayedCityDialog";
export const DISPLAYED_EMAIL_PROMO_DIALOG = "displayedEmailPromoDialog";
export const DISPLAYED_CONSENT_DIALOG = "displayedConsentDialog";
export const DISPLAYED_ADD_ON_DIALOG = "displayedAddOnDialog";
export const DISPLAYED_ONBOARDING_PAYWALL = "displayedOnboardingPaywall";
export const DISPLAYED_INSTAGRAM_ONBOARDING_PAYWALL =
  "displayedInstagramOnboardingPaywall";
export const INSTAGRAM_FOLLOWED = "instagramFollowed";
export const INSTAGRAM_JOINED_CHANNEL = "instagramJoinedChannel";

// VA Steps
export const CURRENT_VA_STEP = "currentVaStep";
export const HIDE_VA_ONBOARDING_VIDEO = "hideVAOnboardingVideos";
export const HIDE_REFERRAL_DIALOG = "hideReferralDialog";
export const MODIFIED_EMAIL_WARMUP = "modifiedEmailWarmup";

// Instagram Onboarding
export const INSTAGRAM_ONBOARDING_CHOICE = "instagramOnboardingChoice";
export const INSTAGRAM_ONBOARDING_FLOW = "instagramOnboardingFlow";
export const INSTAGRAM_EMAIL = "instagramEmail";

// GAMIFICATION
export const GAMIFICATION_UNLOCKED_ALL_FEATURES =
  "gamificationUnlockedAllFeatures";
export const HIDE_ONBOARDING_STEPS = "hideOnboardingSteps";
